import { del, generateClient, isCancelError, post, put } from "aws-amplify/api";

const client = generateClient();

export async function requestListBusinessServiceCategories(dispatch, payload) {
  const { page, limit = 10, nextToken = "start", type = [] } = payload;

  try {
    dispatch({
      type: `REQUEST_LIST_BUSINESS_SERVICE_CATEGORIES`,
      payload: { request: null, page },
    });

    const filter =
      type.length > 0
        ? {
            or: type.map((t) => ({ type: { eq: t } })),
          }
        : null;

    const params = {
      limit,
      ...(filter && { filter }),
    };

    let items = [];
    let token = "start";
    if (nextToken) {
      token = nextToken;
    }

    while (token && items.length === 0) {
      if (token && token !== "start") {
        params.nextToken = token;
      }

      const request = client.graphql({
        query: listBusinessServiceCategories,
        variables: params,
      });
      dispatch({
        type: "REQUEST_LIST_BUSINESS_SERVICE_CATEGORIES",
        payload: { request },
      });

      // eslint-disable-next-line no-await-in-loop
      const res = await request;
      items = [...items, ...res.data.listBusinessServiceCategories.items];
      token = res.data.listBusinessServiceCategories.nextToken;
    }

    dispatch({
      type: `LIST_BUSINESS_SERVICE_CATEGORIES_SUCCESS`,
      payload: {
        businessServiceCategories: items,
        nextToken: token,
        nextPage: page + 1,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_BUSINESS_SERVICE_CATEGORIES_CANCEL",
      });
    } else {
      dispatch({ type: `LIST_BUSINESS_SERVICE_CATEGORIES_ERROR`, error });
    }
  }
}

export async function requestListServiceByCategoryName(dispatch, payload) {
  const {
    categoryID,
    page,
    limit = 10,
    nextToken = "start",
    sortDirection = "DESC",
  } = payload;

  try {
    dispatch({
      type: `REQUEST_LIST_BUSINESS_SERVICES`,
      payload: { request: null, page },
    });

    const params = {
      categoryID,
      limit,
      sortDirection,
    };

    let items = [];
    let token = "start";
    if (nextToken) {
      token = nextToken;
    }

    while (token && items.length === 0) {
      if (token && token !== "start") {
        params.nextToken = token;
      }

      const request = client.graphql({
        query: businessServiceByCategoryName,
        variables: params,
      });
      dispatch({
        type: "REQUEST_LIST_BUSINESS_SERVICES",
        payload: { request },
      });

      // eslint-disable-next-line no-await-in-loop
      const res = await request;
      items = [...items, ...res.data.businessServiceByCategoryName.items];
      token = res.data.businessServiceByCategoryName.nextToken;
    }

    dispatch({
      type: `LIST_BUSINESS_SERVICES_SUCCESS`,
      payload: {
        businessServices: items,
        nextToken: token,
        nextPage: page + 1,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_BUSINESS_SERVICES_CANCEL",
      });
    } else {
      dispatch({ type: `LIST_BUSINESS_SERVICES_ERROR`, error });
    }
  }
}

export async function requestGetBusinessServiceCategory(dispatch, payload) {
  try {
    const { id } = payload;

    dispatch({ type: "REQUEST_GET_BUSINESS_SERVICE_CATEGORY" });

    const params = {
      id,
    };

    const res = await client.graphql({
      query: getBusinessServiceCategory,
      variables: params,
    });

    const businessServiceCategory = res.data.getBusinessServiceCategory;

    dispatch({
      type: "GET_BUSINESS_SERVICE_CATEGORY_SUCCESS",
      payload: { businessServiceCategory },
    });
  } catch (error) {
    dispatch({ type: "GET_BUSINESS_SERVICE_CATEGORY_ERROR", error });
  }
}

export async function requestGetBusinessService(dispatch, payload) {
  try {
    const { id } = payload;

    dispatch({ type: "REQUEST_GET_BUSINESS_SERVICE" });

    const params = {
      id,
    };

    const res = await client.graphql({
      query: getBusinessService,
      variables: params,
    });

    const businessService = res.data.getBusinessService;

    dispatch({
      type: "GET_BUSINESS_SERVICE_SUCCESS",
      payload: { businessService },
    });
  } catch (error) {
    dispatch({ type: "GET_BUSINESS_SERVICE_ERROR", error });
  }
}

export async function requestListBusinessServiceOrder(dispatch, payload) {
  const {
    owner,
    createdAt,
    page,
    limit = 10,
    nextToken = "start",
    sortDirection = "DESC",
  } = payload;

  try {
    dispatch({
      type: `REQUEST_LIST_BUSINESS_SERVICE_ORDER`,
      payload: { request: null, page },
    });

    const params = {
      owner,
      limit,
      sortDirection,
    };

    if (createdAt) {
      params.createdAt = createdAt;
    }

    let items = [];
    let token = "start";
    if (nextToken) {
      token = nextToken;
    }

    while (token && items.length === 0) {
      if (token && token !== "start") {
        params.nextToken = token;
      }

      const request = client.graphql({
        query: serviceOrderByOwnerCreatedAt,
        variables: params,
      });
      dispatch({
        type: "REQUEST_LIST_BUSINESS_SERVICE_ORDER",
        payload: { request },
      });

      // eslint-disable-next-line no-await-in-loop
      const res = await request;
      items = [...items, ...res.data.serviceOrderByOwnerCreatedAt.items];
      token = res.data.serviceOrderByOwnerCreatedAt.nextToken;
    }

    dispatch({
      type: `LIST_BUSINESS_SERVICE_ORDER_SUCCESS`,
      payload: {
        businessServiceOrders: items,
        nextToken: token,
        nextPage: page + 1,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_BUSINESS_SERVICE_ORDER_CANCEL",
      });
    } else {
      dispatch({ type: `LIST_BUSINESS_SERVICE_ORDER_ERROR`, error });
    }
  }
}

export async function requestUpdateServiceOrderStatus(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_UPDATE_SERVICE_ORDER_STATUS",
      payload: { request: null },
    });

    const { orderID, status } = payload;

    const request = put({
      apiName: "business",
      path: `/service/order/${orderID}`,
      options: {
        body: {
          status,
        },
      },
    });

    dispatch({
      type: "REQUEST_UPDATE_SERVICE_ORDER_STATUS",
      payload: { request },
    });

    const { body } = await request.response;
    const res = await body.json();

    const serviceOrderStatusUpdate = res.data;

    dispatch({
      type: "UPDATE_SERVICE_ORDER_STATUS_SUCCESS",
      payload: {
        serviceOrderStatusUpdate,
      },
    });
  } catch (error) {
    dispatch({
      type: "UPDATE_SERVICE_ORDER_STATUS_ERROR",
      error,
    });
  }
}

export async function requestListBusinessServiceOrderByPartner(
  dispatch,
  payload
) {
  const {
    partnerOwner,
    createdAt,
    page,
    limit = 10,
    nextToken = "start",
    sortDirection = "DESC",
  } = payload;

  try {
    dispatch({
      type: `REQUEST_LIST_BUSINESS_SERVICE_ORDER`,
      payload: { request: null, page },
    });

    const params = {
      partnerOwner,
      limit,
      sortDirection,
    };

    if (createdAt) {
      params.createdAt = createdAt;
    }

    let items = [];
    let token = "start";
    if (nextToken) {
      token = nextToken;
    }

    while (token && items.length === 0) {
      if (token && token !== "start") {
        params.nextToken = token;
      }

      const request = client.graphql({
        query: serviceOrderByPartnerOwnerCreatedAt,
        variables: params,
      });
      dispatch({
        type: "REQUEST_LIST_BUSINESS_SERVICE_ORDER",
        payload: { request },
      });

      // eslint-disable-next-line no-await-in-loop
      const res = await request;
      items = [...items, ...res.data.serviceOrderByPartnerOwnerCreatedAt.items];
      token = res.data.serviceOrderByPartnerOwnerCreatedAt.nextToken;
    }

    dispatch({
      type: `LIST_BUSINESS_SERVICE_ORDER_SUCCESS`,
      payload: {
        businessServiceOrders: items,
        nextToken: token,
        nextPage: page + 1,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_BUSINESS_SERVICE_ORDER_CANCEL",
      });
    } else {
      dispatch({ type: `LIST_BUSINESS_SERVICE_ORDER_ERROR`, error });
    }
  }
}

export async function requestGetBusinessServiceOrder(dispatch, payload) {
  try {
    const { id } = payload;

    dispatch({ type: "REQUEST_GET_BUSINESS_SERVICE_ORDER" });

    const params = {
      id,
    };

    const res = await client.graphql({
      query: getBusinessServiceOrder,
      variables: params,
    });

    const businessServiceOrder = res.data.getBusinessServiceOrder;

    dispatch({
      type: "GET_BUSINESS_SERVICE_ORDER_SUCCESS",
      payload: { businessServiceOrder },
    });
  } catch (error) {
    dispatch({ type: "GET_BUSINESS_SERVICE_ORDER_ERROR", error });
  }
}

export async function requestUpdateBusinessService(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_UPDATE_BUSINESS_SERVICE",
      payload: { request: null },
    });

    const { id, input } = payload;

    const request = put({
      apiName: "business",
      path: `/service/${id}`,
      options: {
        body: input,
      },
    });
    dispatch({ type: "REQUEST_UPDATE_BUSINESS_SERVICE", payload: { request } });

    const { body } = await request.response;
    const res = await body.json();
    const businessService = res.data;

    dispatch({
      type: "UPDATE_BUSINESS_SERVICE_SUCCESS",
      payload: { businessService },
    });
  } catch (error) {
    dispatch({ type: "UPDATE_BUSINESS_SERVICE_ERROR", error });
  }
}

export async function requestCreateBusinessService(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_CREATE_BUSINESS_SERVICE",
      payload: { request: null },
    });

    const { input } = payload;

    const request = post({
      apiName: "business",
      path: "/service/create",
      options: {
        body: input,
      },
    });
    dispatch({ type: "REQUEST_CREATE_BUSINESS_SERVICE", payload: { request } });

    const { body } = await request.response;
    const res = await body.json();
    const businessService = res.data;

    dispatch({
      type: "CREATE_BUSINESS_SERVICE_SUCCESS",
      payload: { businessService },
    });
  } catch (error) {
    dispatch({ type: "CREATE_BUSINESS_SERVICE_ERROR", error });
  }
}

export async function requestDeleteBusinessService(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_DELETE_BUSINESS_SERVICE",
      payload: { request: null },
    });
    const { id } = payload;

    const request = del({
      apiName: "business",
      path: `/service/${id}`,
    });
    dispatch({ type: "REQUEST_DELETE_BUSINESS_SERVICE", payload: { request } });

    const { body } = await request.response;
    const res = await body.json();

    dispatch({
      type: "DELETE_BUSINESS_SERVICE_SUCCESS",
      payload: { businessServiceID: res.data.id },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "DELETE_BUSINESS_SERVICE_CANCEL",
      });
    } else {
      dispatch({ type: "DELETE_BUSINESS_SERVICE_ERROR", error });
    }
  }
}

export async function requestListAvailableAddOns(dispatch, payload) {
  const { owner, page, limit = 10, nextToken = "start" } = payload;

  try {
    dispatch({
      type: `REQUEST_LIST_AVAILABLE_ADD_ONS`,
      payload: { request: null, page },
    });

    const params = {
      owner,
      limit,
    };

    let items = [];
    let token = "start";
    if (nextToken) {
      token = nextToken;
    }

    while (token && items.length === 0) {
      if (token && token !== "start") {
        params.nextToken = token;
      }

      const request = client.graphql({
        query: serviceAddOnsByOwner,
        variables: params,
      });
      dispatch({
        type: "REQUEST_LIST_AVAILABLE_ADD_ONS",
        payload: { request },
      });

      // eslint-disable-next-line no-await-in-loop
      const res = await request;
      items = [...items, ...res.data.serviceAddOnsByOwner.items];
      token = res.data.serviceAddOnsByOwner.nextToken;
    }

    dispatch({
      type: `LIST_AVAILABLE_ADD_ONS_SUCCESS`,
      payload: {
        serviceAddons: items,
        nextToken: token,
        nextPage: page + 1,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_AVAILABLE_ADD_ONS_CANCEL",
      });
    } else {
      dispatch({ type: `LIST_AVAILABLE_ADD_ONS_ERROR`, error });
    }
  }
}

export async function requestUpdateServiceAddOn(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_UPDATE_SERVICE_ADDON" });
    const { input } = payload;
    const res = await client.graphql({
      query: updateServiceAddOn,
      variables: { input },
    });
    const addOn = res.data.updateServiceAddOn;
    dispatch({
      type: "UPDATE_SERVICE_ADDON_SUCCESS",
      payload: { addOn },
    });
  } catch (error) {
    dispatch({ type: "ERROR_UPDATE_SERVICE_ADDON", error });
  }
}

export async function requestCreateServiceAddOn(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_CREATE_SERVICE_ADDON" });
    const { input } = payload;
    const res = await client.graphql({
      query: createServiceAddOn,
      variables: { input },
    });
    const addOn = res.data.createServiceAddOn;
    dispatch({
      type: "SUCCESS_CREATE_SERVICE_ADDON",
      payload: { addOn },
    });
  } catch (error) {
    dispatch({ type: "ERROR_CREATE_SERVICE_ADDON", error });
  }
}

export async function requestDeleteServiceAddOn(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_DELETE_SERVICE_ADDON",
      payload: { request: null },
    });
    const { id } = payload;

    const request = del({
      apiName: "business",
      path: `/service/addon/${id}`,
    });
    dispatch({ type: "REQUEST_DELETE_SERVICE_ADDON", payload: { request } });

    const { body } = await request.response;
    const res = await body.json();

    dispatch({
      type: "DELETE_SERVICE_ADDON_SUCCESS",
      payload: { serviceAddOnID: res.data.id },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "DELETE_SERVICE_ADDON_CANCEL",
      });
    } else {
      dispatch({ type: "DELETE_SERVICE_ADDON_ERROR", error });
    }
  }
}

export async function requestListProvinces(dispatch, payload) {
  const { limit = 10 } = payload;

  try {
    dispatch({
      type: `REQUEST_LIST_PROVINCES`,
      payload: { request: null },
    });

    const params = {
      limit,
    };

    let items = [];
    let nextToken = "start";

    while (nextToken) {
      if (nextToken && nextToken !== "start") {
        params.nextToken = nextToken;
      }

      const request = client.graphql({
        query: listProvinces,
        variables: params,
      });
      dispatch({
        type: "REQUEST_LIST_PROVINCES",
        payload: { request },
      });

      const res = await request;
      items = [...items, ...res.data.listProvinces.items];
      nextToken = res.data.listProvinces.nextToken;
    }

    const sortedProvinces = items
      .map((province) => ({
        ...province,
        cities: {
          ...province.cities,
          items: [...province.cities.items].sort((a, b) =>
            a.name.localeCompare(b.name)
          ),
        },
      }))
      .sort((a, b) => a.name.localeCompare(b.name));

    dispatch({
      type: `LIST_PROVINCES_SUCCESS`,
      payload: {
        provinces: sortedProvinces,
      },
    });
  } catch (error) {
    dispatch({ type: `LIST_PROVINCES_ERROR`, error });
  }
}

export async function clearUpdateBusinessService(dispatch) {
  dispatch({ type: "CLEAR_UPDATE_BUSINESS_SERVICE" });
}

export async function clearUpdateServiceAddOn(dispatch) {
  dispatch({ type: "CLEAR_UPDATE_SERVICE_ADDON" });
}

export async function clearUpdateServiceAddOnError(dispatch) {
  dispatch({ type: "CLEAR_UPDATE_SERVICE_ADDON_ERROR" });
}

export async function clearUpdateBusinessServiceError(dispatch) {
  dispatch({ type: "CLEAR_UPDATE_BUSINESS_SERVICE_ERROR" });
}

const listBusinessServiceCategories = /* GraphQL */ `
  query ListBusinessServiceCategories(
    $filter: ModelBusinessServiceCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBusinessServiceCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        type
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const getBusinessServiceCategory = /* GraphQL */ `
  query GetBusinessServiceCategory($id: ID!) {
    getBusinessServiceCategory(id: $id) {
      id
      name
      description
      createdAt
      updatedAt
    }
  }
`;

const businessServiceByCategoryName = /* GraphQL */ `
  query BusinessServiceByCategoryName(
    $categoryID: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBusinessServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    businessServiceByCategoryName(
      categoryID: $categoryID
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        categoryID
        category {
          id
          name
          description
          createdAt
          updatedAt
        }
        consultant {
          id
          user {
            name
          }
          lastSeen
          totalRating
          rating
        }
        price
        basePrice
        name
        description
        benefits
        addOns {
          items {
            id
            addOnID
            addOn {
              id
              name
              description
              price
              basePrice
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        serviceAreas {
          items {
            id
            city {
              id
              name
              province {
                id
                name
              }
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const getBusinessService = /* GraphQL */ `
  query GetBusinessService($id: ID!) {
    getBusinessService(id: $id) {
      id
      status
      categoryID
      category {
        id
        name
        description
        createdAt
        updatedAt
      }
      consultant {
        id
        user {
          name
        }
        lastSeen
        totalRating
        rating
      }
      price
      basePrice
      name
      description
      benefits
      addOns {
        items {
          id
          addOnID
          addOn {
            id
            name
            description
            price
            basePrice
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      serviceAreas {
        items {
          id
          city {
            id
            name
            province {
              id
              name
            }
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;

const serviceOrderByOwnerCreatedAt = /* GraphQL */ `
  query ServiceOrderByOwnerCreatedAt(
    $owner: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBusinessServiceOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceOrderByOwnerCreatedAt(
      owner: $owner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        detail {
          name
          email
          phone
          companyName
        }
        cityID
        city {
          id
          name
          province {
            id
            name
          }
        }
        consultationID
        consultation {
          id
          status
          online
          categoryID
          description
          consultantID
          transactionID
          userID
          scheduleID
          businessServiceOrderID
          callEnabled
          callBalance
          useGlobalBalance
          complaintID
          expiredAt
          updatedAt
          rating
          review
          createdAt
        }
        businessServiceID
        businessService {
          id
          status
          categoryID
          consultantID
          price
          basePrice
          name
          description
          benefits
          serviceAreas {
            items {
              id
              city {
                id
                name
                province {
                  id
                  name
                }
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        addOns {
          items {
            id
            addOn {
              id
              name
              description
              price
              basePrice
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const getBusinessServiceOrder = /* GraphQL */ `
  query GetBusinessServiceOrder($id: ID!) {
    getBusinessServiceOrder(id: $id) {
      id
      status
      detail {
        name
        email
        phone
        companyName
      }
      cityID
      city {
        id
        name
        province {
          id
          name
        }
      }
      consultationID
      consultation {
        id
        status
        online
        categoryID
        description
        consultantID
        transactionID
        userID
        scheduleID
        businessServiceOrderID
        callEnabled
        callBalance
        useGlobalBalance
        complaintID
        expiredAt
        updatedAt
        rating
        review
        createdAt
      }
      businessServiceID
      businessService {
        id
        status
        categoryID
        consultantID
        price
        basePrice
        name
        description
        steps {
          status
          position
          name
          description
          completeDescription
        }
        benefits
        serviceAreas {
          items {
            id
            city {
              id
              name
              province {
                id
                name
              }
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      addOns {
        items {
          id
          addOn {
            id
            name
            description
            price
            basePrice
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;

const serviceOrderByPartnerOwnerCreatedAt = /* GraphQL */ `
  query ServiceOrderByPartnerOwnerCreatedAt(
    $partnerOwner: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBusinessServiceOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceOrderByPartnerOwnerCreatedAt(
      partnerOwner: $partnerOwner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        detail {
          name
          email
          phone
          companyName
        }
        cityID
        city {
          id
          name
          province {
            id
            name
          }
        }
        consultationID
        consultation {
          id
          status
          online
          categoryID
          description
          consultantID
          transactionID
          userID
          scheduleID
          businessServiceOrderID
          callEnabled
          callBalance
          useGlobalBalance
          complaintID
          expiredAt
          updatedAt
          rating
          review
          createdAt
        }
        businessServiceID
        businessService {
          id
          status
          categoryID
          consultantID
          price
          basePrice
          name
          description
          benefits
          serviceAreas {
            items {
              id
              city {
                id
                name
                province {
                  id
                  name
                }
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        addOns {
          items {
            id
            addOn {
              id
              name
              description
              price
              basePrice
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const serviceAddOnsByOwner = /* GraphQL */ `
  query ServiceAddOnsByOwner(
    $owner: String
    $sortDirection: ModelSortDirection
    $filter: ModelServiceAddOnFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceAddOnsByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        price
        basePrice
        owner
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const updateServiceAddOn = /* GraphQL */ `
  mutation UpdateServiceAddOn($input: UpdateServiceAddOnInput!) {
    updateServiceAddOn(input: $input) {
      id
      name
      description
      price
      basePrice
      owner
      createdAt
      updatedAt
    }
  }
`;

const createServiceAddOn = /* GraphQL */ `
  mutation CreateServiceAddOn($input: CreateServiceAddOnInput!) {
    createServiceAddOn(input: $input) {
      id
      name
      description
      price
      basePrice
      createdAt
      updatedAt
    }
  }
`;

const listProvinces = /* GraphQL */ `
  query ListProvinces(
    $filter: ModelProvinceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProvinces(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        cities {
          items {
            id
            name
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
